<div *ngIf="controlDir" class="flex flex-col gap-2">
  <div class="flex justify-between gap-4">
    <label [for]="identifier" class="w-full whitespace-normal break-words text-lg font-bold text-pl-gray-700">
      {{ label | plSlice: 200 }}
    </label>
    <div
      *ngIf="showEyeIconToTogglePassword"
      class="flex cursor-pointer items-center gap-2 text-pl-blue-500"
      (click)="togglePassword()"
    >
      <pl-icon [name]="type === PlInputType.password ? PlIcon.eye : PlIcon.eye_off" class="h-7 w-7" />
      <p class="text-lg text-inherit">
        {{ (type === PlInputType.password ? 'utils.show' : 'utils.hide') | translate }}
      </p>
    </div>
  </div>

  <div class="flex justify-between gap-2">
    <div class="w-full">
      <input
        #inputElement
        class="w-full rounded-md border-2 border-pl-gray-700 px-2.5 py-2.5 font-sans outline-none focus:border-pl-blue-500 focus:bg-pl-gray-100"
        [ngClass]="{
          '!border-pl-error caret-pl-error placeholder:text-pl-error':
            controlDir.invalid && controlDir.dirty && isFormSubmitted,
          '!border-pl-green-500': controlDir.valid && controlDir.dirty,
          'bg-pl-gray-300 text-pl-gray-500': isDisabled
        }"
        [id]="identifier"
        [autocomplete]="autocomplete"
        [value]="value"
        [disabled]="isDisabled"
        [placeholder]="isDisabled ? '' : placeholder"
        [type]="type"
        name="name_{{ name }}"
        (keyup)="onChange($event)"
        (focus)="onCustomInputFocus()"
        (blur)="onBlur()"
      />

      <div
        *ngIf="
          controlDir?.control?.errors &&
          controlDir?.control?.dirty &&
          isFormSubmitted &&
          ((controlDir?.control?.errors?.['required'] && requiredErrorMessage) ||
            !controlDir?.control?.errors?.['required'])
        "
        class="-translate-y-1 bg-pl-error p-2 text-xs italic text-white"
      >
        <span *ngIf="controlDir?.control?.errors?.['required'] && requiredErrorMessage">
          {{ requiredErrorMessage }}
        </span>
        <span *ngIf="controlDir?.control?.errors?.[CustomValidatorErrors.validateEmail]">
          {{ 'login.errors.enter_valid_email' | translate }}
        </span>
        <span *ngIf="controlDir?.control?.errors?.['pattern']">
          <ng-container *ngIf="patternErrorMessage; else genericPatternMessage">{{ patternErrorMessage }}</ng-container>
          <ng-template #genericPatternMessage>
            <ng-container *ngIf="invalidatePatternValidationIfEmojiInValue; else standardPatternMessage">{{
              'blocks.textbox.errorPatternEmoji' | translate
            }}</ng-container>
            <ng-template #standardPatternMessage>
              {{ 'blocks.textbox.errorStandardPattern' | translate }}
            </ng-template>
          </ng-template>
        </span>
        <span *ngIf="controlDir?.control?.errors?.['maxlength']">
          {{ 'errors.max_characters' | translate: { max: controlDir.control?.errors?.['maxlength'].requiredLength } }}
        </span>
      </div>
    </div>

    <pl-icon-custom-control
      *ngIf="showRightIcon"
      [isDirty]="!!controlDir.dirty"
      [isFocused]="isFocused"
      [isValid]="!!controlDir.valid"
      [isDisabled]="isDisabled"
      [isFormSubmitted]="isFormSubmitted"
    />
  </div>
</div>
